import React from 'react';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  height?: number;
  color?: string;
}
export default function Remboursement(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width + 'px' : '22px'}
      height={props.height ? props.height + 'px' : '22px'}
      viewBox="0 0 22 22"
      fill={props.color ? props.color : 'white'}
    >
      <g id="Groupe_97" data-name="Groupe 97" transform="translate(-918 -397)">
        <path
          id="Tracé_38"
          data-name="Tracé 38"
          d="M8.748,11.4a6.524,6.524,0,0,0,.064.976H7.324v.8H8.988A5.283,5.283,0,0,0,14.22,17.1a5.194,5.194,0,0,0,5.152-3.36H18.06a3.933,3.933,0,0,1-3.84,2.352,4.138,4.138,0,0,1-4.048-2.912h4.064v-.8H9.98A6.342,6.342,0,0,1,9.9,11.4a7.049,7.049,0,0,1,.048-.832h4.288v-.8H10.124A4.13,4.13,0,0,1,14.22,6.7,3.912,3.912,0,0,1,18.06,9.08h1.312A5.178,5.178,0,0,0,14.22,5.688a5.293,5.293,0,0,0-5.264,4.08H7.324v.8H8.8A7.049,7.049,0,0,0,8.748,11.4Z"
          transform="translate(915 397)"
          fill="fill"
        />
        <g
          id="Ellipse_13"
          data-name="Ellipse 13"
          transform="translate(918 397)"
          fill="none"
          stroke="fill"
          stroke-width="1"
        >
          <circle cx="11" cy="11" r="11" stroke="none" />
          <circle cx="11" cy="11" r="10.5" fill="none" />
        </g>
      </g>
    </svg>
  );
}
